/*
  Aquamarise "Save for later" -- theme-native, no app. 2026-09-28 (Claude).

  A cart line can be parked in the shopper's browser and moved back into the cart later, the way
  foreveringsjewelry.com/cart does it. Kept separate from the wishlist (assets/aq-wishlist.js): a saved
  line keeps its exact variant, quantity, engraving / size properties and selling plan, which a heart
  does not. The saved pieces show as a horizontal card carousel (the look of the theme's "You may also
  like" cross-sells) on the cart page and inside the cart drawer.

  Storage  localStorage "aq_saved_v1" = { v: 1, items: [ { k, vid, qty, h, id, t, vt, img, price, cmp,
           url, props, sp, cur, avail, ts } ] }   k = variant + selling plan + properties (the dedupe key)
           props is { name: value } (Liquid's `| json` on item.properties gives pairs; normalizeProps fixes that).
  Markup   snippets/aq-sfl-button.liquid renders a [data-aq-sfl-save] button (the line as JSON in data-aq-sfl)
           on every line of the cart page and the drawer. Empty <div data-aq-saved hidden> containers sit in
           sections/main-cart.liquid (under the sign-in block, id aq-saved-for-later, and on the empty-cart
           page) and in sections/quick-cart.liquid (inside the items region above "You may also like", and in
           the empty state). This file paints the carousel into every container and repaints after the theme
           re-renders a section. Styles: assets/aq-save-for-later.css. Both are loaded in <head> on every page
           from snippets/aq-wishlist-config.liquid because the drawer is on every page.
  Cart     "Save for later" stores the line, then clicks the line's own [data-remove-item] button, so the
           theme's cart code (Cart AJAX change.js -> cart:updated) does the removal, the totals, the header
           count and the drawer exactly as a normal Remove. "Move to cart" posts to /cart/add.js, then fires
           the theme's apps:product-added-to-cart event (drawer + header refresh, and the cart page re-renders
           its totals), or reloads when it happens on the EMPTY cart page (that section cannot re-render
           itself from the empty state).
  Catalog  On load every saved piece is refreshed from /products/<handle>.js (price, stock, image); pieces
           that no longer exist are dropped, sold-out ones get a "Notify me when back" button that uses the
           wishlist's Klaviyo back-in-stock subscription.
  Klaviyo  "Added to Wishlist" with Source: "save_for_later" (owner, 2026-09-28) so the wishlist reminder
           flow catches these high-intent shoppers as well. Fire-and-forget, never blocks.
  API      window.AQSaved = { items, add, remove, moveToCart, count }
*/
(function () {
  'use strict';
  if (window.__aqSaved) return;
  window.__aqSaved = true;

  var KEY = 'aq_saved_v1';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = readWishlistConfig();
  var state = load();
  var version = 0; /* bumps on every change; a container painted with an older version is stale */
  var live = null;
  var io = null;

  /* ---------------------------------------------------------------- storage */
  function readWishlistConfig() {
    var c = {};
    try { c = JSON.parse((document.getElementById('aq-wishlist-config') || {}).textContent || '{}'); } catch (e) {}
    c.currency = c.currency || 'USD';
    c.wishlistUrl = c.wishlistUrl || '/pages/wishlist';
    return c;
  }
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s || s.v !== 1 || !Array.isArray(s.items)) s = { v: 1, items: [] };
    for (var i = 0; i < s.items.length; i++) s.items[i].props = normalizeProps(s.items[i].props);
    return s;
  }
  function normalizeProps(p) {
    /* Liquid's `item.properties | json` gives [[name, value], ...]; the Cart AJAX API wants { name: value }. */
    if (!p) return null;
    if (Array.isArray(p)) { var o = {}; for (var i = 0; i < p.length; i++) if (p[i] && p[i].length > 1) o[String(p[i][0])] = p[i][1]; p = o; }
    if (typeof p !== 'object') return null;
    return Object.keys(p).length ? p : null;
  }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function save() {
    persist();
    version++;
    paint();
    try { document.dispatchEvent(new CustomEvent('aq:saved:change', { detail: { items: state.items.slice() } })); } catch (e) {}
  }
  function keyOf(it) {
    var props = (it.props && typeof it.props === 'object') ? it.props : {};
    var flat = Object.keys(props).sort().map(function (k) { return k + '=' + String(props[k]); }).join('&');
    return String(it.vid) + '|' + (it.sp || '') + '|' + flat;
  }
  function find(k) { for (var i = 0; i < state.items.length; i++) if (state.items[i].k === k) return i; return -1; }
  function add(it) {
    if (!it || !it.vid) return false;
    it.k = keyOf(it);
    it.ts = Date.now();
    var i = find(it.k);
    if (i > -1) state.items.splice(i, 1);
    state.items.unshift(it);
    save();
    return true;
  }
  function remove(k) { var i = find(k); if (i < 0) return false; state.items.splice(i, 1); save(); return true; }
  function count() { return state.items.length; }

  /* ---------------------------------------------------------------- Klaviyo */
  function kl(method, args) {
    try {
      if (window.klaviyo && typeof window.klaviyo[method] === 'function') { window.klaviyo[method].apply(window.klaviyo, args); return; }
      (window._learnq = window._learnq || []).push([method].concat(args));
    } catch (e) {}
  }
  function klaviyoTrack(it) {
    var qty = parseInt(it.qty, 10) || 1;
    kl('track', ['Added to Wishlist', {
      ProductID: it.id, VariantID: it.vid, ProductName: it.t, Handle: it.h, VariantTitle: it.vt || '',
      ImageURL: abs(it.img), URL: abs(it.url), Price: num(it.price), CompareAtPrice: num(it.cmp),
      Currency: it.cur || cfg.currency, Available: it.avail !== false, Quantity: qty,
      Source: 'save_for_later', $value: (num(it.price) || 0) * qty
    }]);
  }

  /* ---------------------------------------------------------------- helpers */
  function num(v) { v = parseFloat(v); return isNaN(v) ? undefined : v; }
  function abs(u) { if (!u) return u; if (/^https?:/.test(u)) return u; if (u.indexOf('//') === 0) return location.protocol + u; return location.origin + u; }
  function money(v, cur) {
    v = num(v); if (v === undefined) return '';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur || cfg.currency }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isUpload(v) { return /\/uploads\//.test(String(v)); }
  function visibleProps(props) {
    var out = [];
    if (!props || typeof props !== 'object') return out;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      var v = props[k];
      if (k.charAt(0) === '_' || v === null || v === undefined || String(v) === '') continue;
      out.push([k, String(v)]);
    }
    return out;
  }
  function metaLine(it) {
    var parts = [];
    if (it.vt) parts.push(String(it.vt));
    visibleProps(it.props).forEach(function (p) { parts.push(p[0] + ': ' + (isUpload(p[1]) ? 'uploaded file' : p[1])); });
    return parts.join(' · ');
  }
  function say(msg) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---------------------------------------------------------------- UI */
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>';
  var CROSS = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  function containers() { return document.querySelectorAll('[data-aq-saved]'); }
  function card(it) {
    var sale = it.cmp && num(it.cmp) > num(it.price);
    var soldOut = it.avail === false;
    var qty = parseInt(it.qty, 10) || 1;
    var meta = metaLine(it);
    return '<article class="aq-saved__card" data-aq-saved-item data-k="' + esc(it.k) + '">' +
      '<a class="aq-saved__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
        (it.img ? '<img src="' + esc(it.img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
      '</a>' +
      '<div class="aq-saved__body">' +
        '<h3 class="aq-saved__name fs-body-75"><a href="' + esc(it.url) + '">' + esc(it.t || it.h) + '</a></h3>' +
        (meta ? '<p class="aq-saved__meta" title="' + esc(meta) + '">' + esc(meta) + '</p>' : '') +
        '<p class="aq-saved__price">' +
          (sale ? '<s>' + esc(money(it.cmp, it.cur)) + '</s><span class="sale">' + esc(money(it.price, it.cur)) + '</span>' : esc(money(it.price, it.cur))) +
          (qty > 1 ? '<span class="aq-saved__qty">Qty ' + qty + '</span>' : '') +
          (soldOut ? '<span class="aq-saved__pill">Sold out</span>' : '') +
        '</p>' +
        '<p class="aq-saved__status" data-aq-saved-status hidden></p>' +
        '<div class="aq-saved__actions">' +
          (soldOut
            ? '<button type="button" class="btn btn--tertiary btn--x-small" data-aq-saved-notify><span>Notify me when back</span></button>'
            : '<button type="button" class="btn btn--tertiary btn--x-small" data-aq-saved-move><span>Move to cart</span></button>') +
        '</div>' +
      '</div>' +
      '<button type="button" class="aq-saved__remove" data-aq-saved-remove aria-label="Remove ' + esc(it.t) + ' from saved items">' + CROSS + '</button>' +
    '</article>';
  }
  function paint() {
    var boxes = containers();
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      box.setAttribute('data-aq-painted', String(version));
      if (!state.items.length) { box.innerHTML = ''; box.hidden = true; continue; }
      var id = 'aq-saved-title-' + i;
      box.hidden = false;
      box.innerHTML =
        '<section class="aq-saved" aria-labelledby="' + id + '">' +
          '<div class="aq-saved__head">' +
            '<h2 class="aq-saved__title ff-heading fs-heading-6-base" id="' + id + '">Saved for later <small>(' + state.items.length + ')</small></h2>' +
            '<div class="aq-saved__nav" data-aq-saved-nav hidden>' +
              '<button type="button" class="aq-saved__arrow aq-saved__arrow--prev" data-aq-saved-prev aria-label="Previous saved pieces"><span style="display:inline-flex;transform:scaleX(-1)">' + CHEVRON + '</span></button>' +
              '<button type="button" class="aq-saved__arrow" data-aq-saved-next aria-label="Next saved pieces">' + CHEVRON + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="aq-saved__track" data-aq-saved-track>' + state.items.map(card).join('') + '</div>' +
        '</section>';
      var track = box.querySelector('[data-aq-saved-track]');
      track.addEventListener('scroll', function (e) { updateNav(e.currentTarget.closest('.aq-saved')); }, { passive: true });
      if (io) io.observe(track);
      updateNav(box.querySelector('.aq-saved'));
    }
  }
  function stale() {
    var boxes = containers();
    for (var i = 0; i < boxes.length; i++) if (boxes[i].getAttribute('data-aq-painted') !== String(version)) return true;
    return false;
  }
  function updateNav(section) {
    if (!section) return;
    var track = section.querySelector('[data-aq-saved-track]');
    var nav = section.querySelector('[data-aq-saved-nav]');
    if (!track || !nav) return;
    var overflow = track.scrollWidth > track.clientWidth + 2;
    nav.hidden = !overflow;
    var prev = nav.querySelector('[data-aq-saved-prev]'), next = nav.querySelector('[data-aq-saved-next]');
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  }
  function updateAllNav() { var s = document.querySelectorAll('.aq-saved'); for (var i = 0; i < s.length; i++) updateNav(s[i]); }
  function slide(section, dir) {
    var track = section.querySelector('[data-aq-saved-track]');
    var first = track && track.querySelector('.aq-saved__card');
    if (!track || !first) return;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 10;
    track.scrollBy({ left: dir * (first.offsetWidth + gap), behavior: 'smooth' });
  }

  /* ---------------------------------------------------------------- actions */
  function saveLine(btn) {
    var it = null;
    try { it = JSON.parse(btn.getAttribute('data-aq-sfl') || 'null'); } catch (e) {}
    if (!it || !it.vid) return;
    var line = btn.closest('[data-input-item]');
    var q = line && line.querySelector('[data-quantity-input]');
    var qty = q ? parseInt(q.value, 10) : 0;
    it.qty = qty > 0 ? qty : (parseInt(it.qty, 10) || 1);
    it.props = normalizeProps(it.props);
    it.avail = true;
    var lineKey = it.key; delete it.key;
    btn.disabled = true;
    add(it);
    klaviyoTrack(it);
    say('Saved for later. You will find it under your cart.');
    var rm = line && line.querySelector('[data-remove-item]');
    if (rm) { rm.click(); return; }
    /* Fallback if the theme's Remove handler is ever missing: remove the line ourselves and reload. */
    fetch(ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: 0 }) })
      .then(function () { location.reload(); }, function () { location.reload(); });
  }
  function setStatus(rowEl, msg) {
    var s = rowEl.querySelector('[data-aq-saved-status]');
    if (!s) return;
    s.textContent = msg || '';
    s.hidden = !msg;
  }
  function moveToCart(k, rowEl) {
    var i = find(k); if (i < 0) return;
    var it = state.items[i];
    var btn = rowEl.querySelector('[data-aq-saved-move]');
    if (btn && btn.disabled) return;
    if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Adding…'; }
    setStatus(rowEl, '');
    var line = { id: Number(it.vid), quantity: parseInt(it.qty, 10) || 1 };
    if (it.props && typeof it.props === 'object' && Object.keys(it.props).length) line.properties = it.props;
    if (it.sp) line.selling_plan = it.sp;
    function failed(msg) {
      if (btn) { btn.disabled = false; btn.querySelector('span').textContent = 'Move to cart'; }
      setStatus(rowEl, msg || 'Could not add this piece. Please try again.');
    }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [line] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j || {} }; }, function () { return { ok: r.ok, j: {} }; });
    }).then(function (res) {
      if (!res.ok || res.j.status === 422 || res.j.errors) {
        var msg = res.j.description || res.j.message || (typeof res.j.errors === 'string' ? res.j.errors : '');
        if (/sold out|not available|unavailable/i.test(msg)) { it.avail = false; save(); return; }
        failed(msg);
        return;
      }
      state.items.splice(find(k), 1);
      /* The cart page's own section cannot re-render itself out of the empty state; everywhere else the
         theme refreshes the drawer, the header count and (on the cart page) the totals on this event. */
      var cartPage = document.querySelector('[data-section-type="cart"]');
      if (cartPage && !document.querySelector('[js-cart-items]')) { persist(); location.reload(); return; }
      save();
      say(it.t + ' moved to your cart.');
      try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); } catch (e) {}
    }).catch(function () { failed(); });
  }
  function notify(k, rowEl) {
    var i = find(k); if (i < 0) return;
    var it = state.items[i];
    var W = window.AQWishlist;
    var btn = rowEl.querySelector('[data-aq-saved-notify]');
    var label = btn && btn.querySelector('span');
    if (W && typeof W.email === 'function' && W.email() && typeof W.subscribeBackInStock === 'function') {
      if (btn) { btn.disabled = true; if (label) label.textContent = 'Saving…'; }
      W.subscribeBackInStock({ email: W.email(), variantId: it.vid })
        .then(function () { if (label) label.textContent = 'We will email you'; })
        .catch(function () { if (btn) { btn.disabled = false; if (label) label.textContent = 'Try again'; } });
      return;
    }
    /* No email on file yet: keep the piece on the wishlist too, whose page has the alerts form. */
    if (W && typeof W.add === 'function') {
      W.add({ h: it.h, id: it.id, vid: it.vid, t: it.t, img: it.img, price: it.price, cmp: it.cmp, url: it.url, avail: false, cur: it.cur });
    }
    location.href = cfg.wishlistUrl;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var saveBtn = t.closest('[data-aq-sfl-save]');
    if (saveBtn) { e.preventDefault(); saveLine(saveBtn); return; }
    var nav = t.closest('[data-aq-saved-prev], [data-aq-saved-next]');
    if (nav) { e.preventDefault(); slide(nav.closest('.aq-saved'), nav.hasAttribute('data-aq-saved-prev') ? -1 : 1); return; }
    var item = t.closest('[data-aq-saved-item]');
    if (!item) return;
    var k = item.getAttribute('data-k');
    if (t.closest('[data-aq-saved-move]')) { e.preventDefault(); moveToCart(k, item); }
    else if (t.closest('[data-aq-saved-remove]')) { e.preventDefault(); remove(k); say('Removed from your saved items.'); }
    else if (t.closest('[data-aq-saved-notify]')) { e.preventDefault(); notify(k, item); }
  });

  /* ---------------------------------------------------------------- catalogue refresh */
  function productJson(h) {
    var k = 'aq_p_' + h, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) {}
    if (cached && cached.t > Date.now() - 30 * 60 * 1000) return Promise.resolve(cached.p);
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status); return r.json();
    }).then(function (p) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {} return p; });
  }
  function refresh(it, p) {
    var v = null;
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(it.vid)) v = p.variants[i];
    if (!v) { it.gone = true; return; }
    it.id = p.id; it.t = p.title;
    it.avail = !!v.available;
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    if (img) it.img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
    it.price = (v.price / 100).toFixed(2);
    it.cmp = (v.compare_at_price && v.compare_at_price > v.price) ? (v.compare_at_price / 100).toFixed(2) : '';
    it.url = ROOT + 'products/' + p.handle + (p.variants.length > 1 ? '?variant=' + v.id : '');
    if (p.variants.length > 1) {
      /* "Size: 7 · Metal: Silver" rather than the bare "7 / Silver" variant title (also upgrades older saves). */
      var parts = [];
      (p.options || []).forEach(function (opt, i) {
        var name = (opt && typeof opt === 'object') ? opt.name : opt;
        var val = v['option' + (i + 1)];
        if (!val || /^default title$/i.test(val)) return;
        parts.push((!name || /^title$/i.test(String(name)) ? '' : String(name) + ': ') + val);
      });
      it.vt = parts.join(' · ');
    }
  }
  function refreshAll() {
    if (!state.items.length) return;
    Promise.all(state.items.map(function (it) {
      return productJson(it.h).then(function (p) { refresh(it, p); }, function (e) { if (String(e.message) === '404') it.gone = true; });
    })).then(function () {
      state.items = state.items.filter(function (it) { return !it.gone; });
      save();
    });
  }

  /* ---------------------------------------------------------------- boot */
  window.AQSaved = {
    items: function () { return state.items.slice(); }, add: add, remove: remove, count: count,
    moveToCart: function (k) { var el = document.querySelector('[data-aq-saved-item][data-k="' + String(k).replace(/"/g, '\\"') + '"]'); if (el) moveToCart(k, el); }
  };
  /* Arrows only make sense once a carousel is actually on screen (the drawer opens later), so measure then. */
  if (window.IntersectionObserver) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) updateNav(en.target.closest('.aq-saved')); });
    });
  }
  paint();
  if (containers().length) refreshAll();
  window.addEventListener('resize', function () { clearTimeout(updateAllNav.__t); updateAllNav.__t = setTimeout(updateAllNav, 120); });
  /* Deep link from an older drawer build: scroll to the cart page list once it is painted. */
  if (location.hash === '#aq-saved-for-later' && count()) {
    setTimeout(function () {
      var box = document.getElementById('aq-saved-for-later');
      if (box && !box.hidden) window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
    }, 250);
  }
  /* The theme re-renders the cart section when the cart empties (and on every quantity change re-renders
     the line list), and re-renders the drawer's items region on every change (the whole container when it
     empties or refills); freshly rendered [data-aq-saved] containers are blank, so repaint them. Own paints
     never look stale. */
  var roots = document.querySelectorAll('[data-section-type="cart"], [data-section-type="quick-cart"]');
  if (roots.length) {
    var mo = new MutationObserver(function () {
      if (mo.__t) return;
      mo.__t = setTimeout(function () { mo.__t = 0; if (stale()) paint(); }, 60);
    });
    for (var r = 0; r < roots.length; r++) mo.observe(roots[r], { childList: true, subtree: true });
  }
})();